/** Quarantined synchronous bridge for legacy readers. Original objects are never edited. */
export function withPlanCaptureState(state, { camera, showGrid, maxProjectBytes = 32 * 1024 * 1024 }, callback) {
  const serialized = JSON.stringify(state.project);
  if (!serialized || serialized.length * 2 > maxProjectBytes) throw new RangeError('Plan export exceeds project snapshot budget');
  const project = structuredClone(state.project);
  project.currentView = 'plan';
  if (showGrid !== undefined) project.showGrid = showGrid === true;
  const overrides = {
    project, camera2D: { ...(camera || state.camera2D) },
    selection: { items: [], groupId: null, unitId: null, unitIds: [], obstacleId: null, objectAssetId: null, objectAssetIds: [], sketchWall: { nodeId: null, wallId: null, angleId: null, openingId: null }, sketchWallIds: [] },
    ui: {}, drag: { active: false, type: null }, floorplanMeasure: { active: false, points: [] },
    file: { ...state.file }, history: { undo: [], redo: [], limit: 0 }
  };
  const previous = new Map(Object.keys(overrides).map(key => [key, Object.getOwnPropertyDescriptor(state, key)]));
  try {
    Object.assign(state, overrides);
    const result = callback();
    if (result?.then) { Promise.resolve(result).catch(() => undefined); throw new TypeError('Plan capture state must be synchronous'); }
    return result;
  } finally {
    for (const [key, descriptor] of previous) {
      if (descriptor) Object.defineProperty(state, key, descriptor); else delete state[key];
    }
  }
}
